import type { PropertySchema } from '@takeshape/schema';
import asNumber from './as-number.js';
import type { ImmutableMap } from './immutable-types.js';

/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */
export default function coerceValue(schema: ImmutableMap<PropertySchema>, value: unknown) {
  const type = schema.get('type');
  if (type === 'array') {
    const itemType = schema.getIn(['items', 'type']);
    if (itemType === 'integer' || itemType === 'number') {
      return (value as string[]).map(asNumber);
    }
  } else if (type === 'boolean') {
    return value === 'true';
  } else if (type === 'number') {
    return asNumber(value as string);
  }

  return value;
}
